import React from 'react';
import { observer } from 'mobx-react';
import { Table } from 'antd';
import { IBillingSystemOrdersListItem } from '../../../interfaces';
import { useBillingOrdersTable, useUiIsLoading, useUiSearch } from '../../../hooks';
import { lightText, stringMoney } from '../../../instruments';
import { tF, tI } from '../../../translate';
import { Catcher, LinkComponent, TableItemToolbar, columnToolbar } from '../../../Components';
import '../../../customStyle/table.less';
import ItemStyles from '../../styles/m_itemCardStyles.less';
import Styles from '../../styles/m_viewStyles.less';

export const BillingOrdersTableList: React.FC = observer(() => {
    const isLoading = useUiIsLoading();
    const list = useBillingOrdersTable();
    const search = useUiSearch();

    const tableColumns = [
        {
            title: tF('ID'),
            dataIndex: 'idLink',
        },
        {
            title: tF('Date'),
            dataIndex: 'dateLink',
        },
        {
            title: tF('Company'),
            dataIndex: 'companyLink',
        },
        {
            title: tF('User'),
            dataIndex: 'userLink',
        },
        {
            title: tF('Payment Method'),
            dataIndex: 'paymentType',
        },
        {
            title: tF('Description'),
            dataIndex: 'descriptionLink',
        },
        {
            title: tF('Cost'),
            dataIndex: 'costText',
            className: Styles.columnRight,
        },
        {
            title: tF('Status'),
            dataIndex: 'statusOverall',
            className: Styles.columnRight,
        },
        columnToolbar,
    ];

    const tableData = list?.map((order: IBillingSystemOrdersListItem) => {
        const statusColor =
            order.statusOverall === 'pending'
                ? ItemStyles.billingOrderStatusNamePending
                : order.statusOverall === 'paid'
                ? ItemStyles.billingOrderStatusNamePaid
                : ItemStyles.billingOrderStatusNameFailed;
        return {
            key: order.id,
            ...order,
            idLink: <LinkComponent currentListComponent={'BillingOrdersList'} id={order.id} />,
            dateLink: <LinkComponent currentListComponent={'BillingOrdersList'} id={order.id} name={order.updatedAt} />,
            descriptionLink: (
                <LinkComponent currentListComponent={'BillingOrdersList'} id={order.id} name={order.description} />
            ),
            companyLink: (
                <LinkComponent
                    currentListComponent={'BillingCompaniesList'}
                    id={order?.companyId?.id}
                    isLight
                    name={order?.companyId?.name}
                />
            ),
            userLink: order?.user?.name,
            paymentType: lightText(order.paymentTypeId, search),
            statusOverall: <span className={statusColor}>{lightText(order.statusOverall?.toUpperCase(), search)}</span>,
            costText: stringMoney(order.amount, order?.currencyId?.abbreviation),
            toolbar: <TableItemToolbar id={order?.id || ''} itemName={`"${order.id}" ${tI('order')}`} />,
        };
    });

    return (
        <Catcher>
            <div className={Styles.tablePlace}>
                <Table
                    className={'table-theme'}
                    columns={tableColumns}
                    dataSource={tableData}
                    loading={isLoading}
                    pagination={false}
                    size={'middle'}
                />
            </div>
        </Catcher>
    );
});
